import { createRouter } from '@swan-io/chicane'
import { match } from 'ts-pattern'

export const Router = createRouter(
  {
    Root: '/?:date',
    Auth: '/auth',
    ResetPassword: '/auth/reset_password/:token',
    User: '/user',
    ProgramIndex: '/program',
    ProgramView: '/program/:id',
    ProgramWorkoutView: '/program_workout/:id',
    WorkoutExerciseView: '/workout/:id',
    ExerciseIndex: '/exercise',
    ExerciseView: '/exercise/:id',
    ActivityIndex: '/activity',
    ActivityView: '/activity/:id',
    ProgressionIndex: '/progression',
    ProgressionView: '/progression/:id',
    StatsIndex: '/stats',
    StatsMax: '/stats/max',
    StatsVolume: '/stats/volume',
    CompletedSetsIndex: '/completed_sets',
    Quickadd: '/quickadd',
  },
  {
    basePath: '/app',
  }
)

export type RouteConfig = {
  topbar?: {
    name?: string
    enabled?: boolean
  }
}

export function useAllRoutes() {
  return Router.useRoute([
    'Root',
    'Auth',
    'User',
    'ProgramIndex',
    'ProgramView',
    'ProgramWorkoutView',
    'WorkoutExerciseView',
    'ExerciseIndex',
    'ExerciseView',
    'ActivityIndex',
    'ActivityView',
    'ProgressionIndex',
    'ProgressionView',
    'StatsVolume',
    'StatsMax',
    'StatsIndex',
    'CompletedSetsIndex',
    'Quickadd',
  ])
}

export function matchRouteConfig(
  route: ReturnType<typeof Router.useRoute>
): RouteConfig {
  return match(route)
    .with({ name: 'Root' }, () => ({ topbar: { name: 'Dashboard' } }))
    .with({ name: 'Auth' }, () => ({ topbar: { name: 'Register & Login' } }))
    .with({ name: 'User' }, () => ({ topbar: { name: 'User & Profile' } }))
    .with({ name: 'ProgramIndex' }, () => ({
      topbar: { name: 'Programs List' },
    }))
    .with({ name: 'ProgramView' }, () => ({ topbar: { name: 'Program' } }))
    .with({ name: 'ProgressionIndex' }, () => ({
      topbar: { name: 'Progressions List' },
    }))
    .with({ name: 'ProgressionView' }, () => ({
      topbar: { name: 'Progression' },
    }))
    .with({ name: 'ProgramWorkoutView' }, () => ({
      topbar: { name: 'Program Workout' },
    }))
    .with({ name: 'WorkoutExerciseView' }, () => ({
      topbar: { name: 'Workout Exercise' },
    }))
    .with({ name: 'ExerciseIndex' }, () => ({
      topbar: { name: 'Exercises List' },
    }))
    .with({ name: 'ExerciseView' }, () => ({ topbar: { name: 'Exercise' } }))
    .with({ name: 'ActivityIndex' }, () => ({
      topbar: { name: 'Activity History' },
    }))
    .with({ name: 'ActivityView' }, () => ({ topbar: { enabled: false } }))
    .with({ name: 'CompletedSetsIndex' }, () => ({
      topbar: { name: 'Completed Sets List' },
    }))
    .with({ name: 'StatsIndex' }, () => ({ topbar: { name: 'Stats' } }))
    .otherwise(() => ({ topbar: { enabled: false } }))
}
